import { EffectReducer } from 'use-effect-reducer';

export interface StayLength {
  key: string;
  label: string;
  value: $TSFixMe
}

export interface FiltersState {
  property?: any;
  stayLength?: string;
  rateTags?: $TSFixMe;
  firstDay: $TSFixMe;
  focusDate: $TSFixMe;
  userInteraction?: boolean;
  firstDateFocusable?: $TSFixMe;
  layout?: string;
  stayLengthData?: Array<StayLength>;
}

export const filtersReducer: EffectReducer<FiltersState, any, any> = (state, action, exec) => {
  exec({ type: 'tracking', action, prevState: state });

  if (action.category !== 'tracking') {
    switch (action.type) {
      case 'LAYOUT_CHANGE': {
        return {
          ...state,
          layout: action.payload
        };
      }
      case 'MONTH_CHANGE':
      case 'DATE_RANGE_CHANGE': {
        return {
          ...state,
          dateRange: action.payload,
          firstDay: action.payload.start,
          focusDate: action.payload.start
        };
      }
      case 'PROPERTY_CHANGE': {
        return {
          ...state,
          property: action.payload,
          focusDate: state.firstDay,
          firstDateFocusable: undefined
        };
      }
      case 'STAY_LENGTH_CHANGE': {
        return {
          ...state,
          stayLength: action.payload.value,
          focusDate: state.firstDay
        };
      }
      case 'STAY_LENGTH_CLEAR': {
        return {
          ...state,
          stayLength: {}
        };
      }
      case 'RATES_TAGS_CHANGE': {
        return {
          ...state,
          stayLength: action.payload.find((item: $TSFixMe) => item.value === 'WEEKEND') ? state?.stayLengthData && state.stayLengthData[1]?.value : state.stayLength,
          rateTags: action.payload,
          focusDate: state.firstDay,
          firstDateFocusable: undefined
        };
      }
      case 'PROPERTY_CLEAR': {
        let newReturn = {
          ...state,
          property: {},
          stayLength: {},
          rateTags: [],
          focusDate: state.firstDay,
          firstDateFocusable: undefined
        };
        return newReturn;
      }
      case 'BUDGET_CHANGE': {
        return {
          ...state,
          budget: action.payload
        };
      }
      case 'BUDGET_CLEAR': {
        return {
          ...state,
          budget: null
        };
      }
      case 'CLEAR_ALL': {
        return {
          ...state,
          property: {},
          dateRange: {},
          budget: null,
          stayLength: {},
          ...action.payload
        };
      }
      case 'SET_FOCUS_DATE': {
        return { ...state, focusDate: action.payload, firstDateFocusable: undefined };
      }
      case 'SET_FOCUS_DATE_WEEKEND': {
        return { ...state, focusDate: action.payload, firstDateFocusable: action.payload };
      }
      case 'SET_FIRST_DAY': {
        return { ...state, firstDay: action.payload };
      }
      case 'SET_USER_INTERACTION_ACTION':
        return { ...state, userInteraction: action.payload };
    }
  }
  return state;
};
